// extracted by mini-css-extract-plugin
module.exports = {"ResponsiveContainerRefSkin":"_3V5_4","responsiveContainerRefSkin":"_3V5_4"};